// extracted by mini-css-extract-plugin
module.exports = {"subtopicsList":"Topic_subtopicsList__3UlHf","subtopicsListItem":"Topic_subtopicsListItem__F70ct"};